.container {
	width: 300px;
	padding: calc(var(--jpo-common-base-spacing) * 2);
	display: flex;
	flex-direction: column;
	gap: calc(var(--jpo-common-base-spacing) * 2);
}

.content {
	display: flex;
}

.swap {
	width: 20px;
	display: flex;
	flex-direction: column;
	margin-right: var(--jpo-common-base-spacing);
	& button {
		height: 20px;
		flex-shrink: 0;
		border: 2px solid var(--ds-border, var(--adg3-color-N50));
	}
}

.swapLine {
	flex-grow: 1;
	position: relative;
	&::before {
		content: '';
		position: absolute;
		left: 50%;
		width: 2px;
		height: calc(100% - 24px);
		transform: translateX(-50%);
		background-color: var(--ds-border, var(--adg3-color-N50));
	}
	&::after {
		content: '';
		position: absolute;
		left: 50%;
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background-color: var(--ds-border, var(--adg3-color-N50));
		transform: translateX(-50%);
	}
}

.swapLineTop {
	&::before {
		bottom: 0;
	}
	&::after {
		top: calc(20px - 4px);
	}
}

.swapLineBottom {
	&::before {
		top: 0;
	}
	&::after {
		bottom: calc(20px - 4px);
	}
}

.form {
	display: flex;
	flex-direction: column;
	gap: var(--jpo-common-base-spacing);
	flex-grow: 1;
}

.actions {
	display: flex;
	justify-content: flex-end;
	gap: var(--jpo-common-base-spacing);
}

.warning {
	display: flex;
	gap: var(--jpo-common-base-spacing);
}
